
import axiosInstance from "../../axios/axiosTokenMiddleware";
import { baseUrl, version, mode, role, inventory } from "../../config/config"

const URL = `${baseUrl}${version}${mode}${role}${inventory}`;

export const inventorySparesDownloadFile = async (url) => {
  try {
    const response = await axiosInstance.get(url, {
      responseType: "arraybuffer",
    });

    console.log("Downloaded file data:", response);

    return response.data;
  } catch (error) {
    console.error("Error downloading the file:", error);
    throw error; 
  }
};

export const inventorySparesDownloadRequest = async ({ requestId }) => {
  try {
    const downloadUrl = `${URL}spares/${requestId}/download_file`;
    console.log("URL:", downloadUrl);
    const fileData = await inventorySparesDownloadFile(downloadUrl);

    console.log("Downloaded file data:", fileData);

    return fileData;
  } catch (error) {
    console.error("Error during download request:", error);
    throw error;
  }
};


export const inventorySparesDownloadFailedRequest = async ({ category, requestId }) => {
  try {
    const downloadUrl = `${URL}${category}/download_failed_images?request_id=${requestId}`;
    console.log("URL:", downloadUrl);
    const fileData = await inventorySparesDownloadFile(downloadUrl);

    console.log("Downloaded file data:", fileData);

    return fileData;
  } catch (error) {
    console.error("Error during download request:", error);
    throw error;
  }
};


export const inventorySparesRescanRequest = async ({ category, requestId }) => {
  try {
    const downloadUrl = `${URL}${category}/rescan?request_id=${requestId}`;
    console.log("URL:", downloadUrl);
    const fileData = await inventorySparesDownloadFile(downloadUrl);

    console.log("Downloaded file data:", fileData);

    return fileData;
  } catch (error) {
    console.error("Error during download request:", error);
    throw error;
  }
};